"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var actionCreator_1 = require("./actionCreator");
var dispatcher_1 = require("./dispatcher");
var globalContext_1 = require("./globalContext");
function mutator(actionCreator, target) {
    var actionId = actionCreator_1.getPrivateActionId(actionCreator);
    if (!actionId) {
        throw new Error('Mutators can only subscribe to action creators.');
    }
    var wrappedTarget = mobx_1.action(actionCreator_1.getPrivateActionType(actionCreator), function (actionMessage) {
        try {
            globalContext_1.getGlobalContext().currentMutator = actionCreator.name;
            target(actionMessage);
        }
        finally {
            globalContext_1.getGlobalContext().currentMutator = null;
        }
    });
    dispatcher_1.subscribe(actionId, wrappedTarget);
    return target;
}
exports.default = mutator;
